module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.68ea4734.ttf";